import React, { useEffect, useRef, useState } from "react";
import "./timeLineBar.scss";
import { JulianDate } from "cesium";

//time line multipliers
const allowedMultipliers = [1, 2, 3, 5, 10];

const TimeLineBarComponent = () => {
  const [isPlaying, setIsPlaying] = useState();
  const [multiplier, setMultiplier] = useState();
  const [currentTime, setCurrentTime] = useState();
  const [showToolbar, setShowToolbar] = useState(true);

  const multiplierRef = useRef();

  useEffect(() => {
    multiplierRef.current = multiplier;
  }, [multiplier]);

  useEffect(() => {
    const updateCurrentTime = () => {
      const time = getLocalTime(viewer.clock.currentTime);
      setCurrentTime(time);

      // checkIfDateIsFuture();
      // Update the displayed multiplier if it changes externally
      const currentMultiplier = viewer.clock.multiplier;
      if (multiplier !== currentMultiplier) {
        setMultiplier(currentMultiplier);
      }

      const currentPlayMode = viewer.clock.shouldAnimate;
      if (isPlaying != currentMultiplier) {
        setIsPlaying(currentPlayMode);
      }
    };

    const onTick = viewer.clock.onTick.addEventListener(updateCurrentTime);

    const timelineContainer = document.getElementsByClassName(
      "cesium-viewer-timelineContainer"
    )[0];
    const targetContainer = document.getElementsByClassName(
      "custom-timeline-container"
    )[0];
    targetContainer.appendChild(timelineContainer);

    // Cleanup when component unmounts
    return () => {
      onTick(); // Remove event listener
    };
  }, []);

  const checkIfDateIsFuture = () => {
    var currentDate = JulianDate.now();
    let clockTime = viewer.clock.currentTime
    let newCurrentDate = currentDate.clone();
    JulianDate.addSeconds(currentDate, -1, newCurrentDate);

    var isCurrentDateInFuture = JulianDate.greaterThan(
      clockTime,
      newCurrentDate
    );

    if (isCurrentDateInFuture) {
      // Set the clock speed to real-time (speed = 1)
      viewer.clock.multiplier = 1;

      // Set Cesium Clock to the current date and time
      viewer.clock.currentTime = newCurrentDate.clone();
    }
  };

  const handlePlayPause = (e) => {
    e.currentTarget.blur(); // Remove focus

    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      viewer.clock.shouldAnimate = true;
    } else {
      viewer.clock.shouldAnimate = false;
    }
  };

  const handleDecreaseMultiplier = (e) => {
    e.currentTarget.blur();
    adjustMultiplier("decrease");
  };

  const handleIncreaseMultiplier = (e) => {
    e.currentTarget.blur();
    adjustMultiplier("increase");
  };

  const adjustMultiplier = (operation) => {
    let newMultiplier = multiplier;
    if (operation === "increase") {
      for (let i = 0; i < allowedMultipliers.length; i++) {
        if (allowedMultipliers[i] > multiplier) {
          newMultiplier = allowedMultipliers[i];
          break;
        }
      }
    } else if (operation === "decrease") {
      for (let i = allowedMultipliers.length - 1; i >= 0; i--) {
        if (allowedMultipliers[i] < multiplier) {
          newMultiplier = allowedMultipliers[i];
          break;
        }
      }
    }
    setMultiplier(newMultiplier);
    viewer.clock.multiplier = newMultiplier;
  };

  function getLocalTime(time) {
    const localDate = JulianDate.toDate(time);
    const hour = localDate.getHours();
    const minute = localDate.getMinutes();
    const second = localDate.getSeconds();

    return `${twoDigits(hour)}:${twoDigits(minute)}:${twoDigits(second)}`;
  }

  function twoDigits(num) {
    return num.toString().padStart(2, "0");
  }

  return (
    <div className="timeline-bar-container">
      <div className="timeline-bar-controls">
        <button onClick={handleDecreaseMultiplier}>
          <img src="./icons/minus.svg" alt="Decrease Speed" />
        </button>

        <span className="multiplier">{multiplier}</span>
        <span>x</span>
        <button onClick={handleIncreaseMultiplier}>
          <img src="./icons/plus.svg" alt="Increase Speed" />
        </button>

        <button className="play-pause" onClick={handlePlayPause}>
          <img
            src={isPlaying ? "./icons/pause.svg" : "./icons/play.svg"}
            alt="Play/Pause"
          />
        </button>
      </div>
      <div style={{flex:10}} className="custom-timeline-container"></div>
      <div className="timeline-bar-controls timeline-bar-clock">
        <span className="current-time">{currentTime}</span>
      </div>
    </div>
  );
};

export default TimeLineBarComponent;
